const ALL_PATHWAY_COMPLETION_STATUS_LIST = [
  "Participant In Progress",
  "Participator",
  "Concentrator",
  "Completer",
];

enum PATHWAY_STATUS  {
  OUTSTANDING = "Outstanding",
  NOT_STARTED = "Not Started",
  IN_PROGRESS = "In Progress",
  COMPLETED = "Completed",
  FAILED = "Failed",
}
enum PATHWAY_STATUS_ID  {
  OUTSTANDING = '0',
  NOT_STARTED = '1',
  IN_PROGRESS = '2',
  COMPLETED = '3',
  FAILED = '4',
}

const PATHWAY_STATUS_LIST = [
  PATHWAY_STATUS.OUTSTANDING,
  PATHWAY_STATUS.NOT_STARTED,
  PATHWAY_STATUS.IN_PROGRESS,
  PATHWAY_STATUS.COMPLETED,
  PATHWAY_STATUS.FAILED,
];


export const StudentCreTrackingConstants = {
  ALL_PATHWAY_COMPLETION_STATUS_LIST,
  PATHWAY_STATUS_LIST,
  PATHWAY_STATUS_ID,
  PATHWAY_STATUS,
} as const;
